import React from 'react';
import { Button } from 'reactstrap';
import {
  Link,
  withRouter,
  RouteComponentProps,
  matchPath,
  generatePath,
} from 'react-router-dom';

const EditPatientButton = (
  props: RouteComponentProps<{ organizationId: string; patientId: string }> & {
    loading?: boolean;
    disabled?: boolean;
  },
) => {
  const path = '/organization/:organizationId/patient/:patientId/edit';
  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: '/organization/:organizationId/patient/:patientId',
    },
  );
  const gPath = match ? generatePath(path, match.params) : undefined;
  return (
    <Button
      tag={Link}
      color="success"
      className="text-center float-right"
      to={gPath}
      disabled={!gPath || props.loading || props.disabled}>
      Edit
    </Button>
  );
};

export default withRouter(EditPatientButton);
